import Utilx from '@byted/fe-utilx';
import buildtimeEnv from './buildtimeEnv.json';
var Util = new Utilx({
    defaultLanguage: 'zh',
});
export var isRN = Util.isRN, isInApp = Util.inApp, osName = Util.osName, osVersion = Util.osVersion, appName = Util.appName, queryParamsFromGlobal = Util.queryParamsFromGlobal, statusBarHeight = Util.statusBarHeight, appVersion = Util.appVersion, isAndroid = Util.isAndroid, isIOS = Util.isIOS, isIPhoneX = Util.isIPhoneX, currentLangFromApp = Util.currentLangFromApp, currentLang = Util.currentLang;
export var isTiktok = appName === 'trill' || appName === 'tiktok';
export var isQQBrowser = appName === 'qqbrowser';
export var isSafari = appName === 'safari';
export var currentVersion = typeof appVersion === 'string' ? parseInt(appVersion, 10) : 0;
export var BUILD_TYPE = buildtimeEnv.BUILD_TYPE;
var rtlLangs = ['ar', 'ur', 'he'];
function localeIsRtl(locale) {
    var lang = locale === null || locale === void 0 ? void 0 : locale.split('-')[0];
    return rtlLangs.includes(lang);
}
export var isRTL = localeIsRtl(currentLang);
export var isTTP = buildtimeEnv.BUILD_REGION === 'oci';
